export default __webpack_public_path__ + "static/tanmai-0110a5385b5349ecd81ca9bf58f873c1.png";